import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zendesk",
  "use": "icon-zendesk-usage",
  "viewBox": "0 0 97.35 78.09",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 97.35 78.09\" id=\"icon-zendesk\"><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path d=\"M.011 68.427L19.358.01l34.209 9.673L34.22 78.1zM97.565 68.385l-34.128 9.598-9.598-34.128 34.128-9.598z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol